import { render, staticRenderFns } from "./AllergensStatusMessage.vue?vue&type=template&id=4d652389&scoped=true"
import script from "./AllergensStatusMessage.vue?vue&type=script&lang=js"
export * from "./AllergensStatusMessage.vue?vue&type=script&lang=js"
import style0 from "./AllergensStatusMessage.vue?vue&type=style&index=0&id=4d652389&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d652389",
  null
  
)

export default component.exports